import React from 'react';
import { isEmpty, map } from 'lodash';
import { ErrorBoundary } from 'react-error-boundary';

import AnalyticsUtils from 'js/lib/AnalyticsUtils';

import ErrorFallback from '../errors/ErrorFallback';
import CardDetailViewHeader from './CardDetailViewHeader';

import './CardDetailView.scss';

class CardDetailView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tabs: null,
      tabNames: null,
      selectedTabIndex: 0,
      meta: null,
    };

    this._getSourceMeta = this._getSourceMeta.bind(this);
    this._handleTabClicked = this._handleTabClicked.bind(this);
    this._renderContent = this._renderContent.bind(this);
    this._selectDefaultTab = this._selectDefaultTab.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.props.data) {
      return;
    }
    if (this.props.data.id !== prevProps.data.id) {
      //TODO:R16: can we even end here?
      const meta = this._getSourceMeta(this.props.data.id);
      const tabs = this.props.tabs;
      const tabNames = map(tabs, 'tabName');
      this.setState({ meta, tabs, tabNames, selectedTabIndex: 0 });
    }

    if (this.props.preSelectedTab !== prevProps.preSelectedTab && this.props.preSelectedTab) {
      this._selectDefaultTab();
    }
  }

  componentDidMount() {
    this._selectDefaultTab();
  }

  _selectDefaultTab() {
    const meta = this._getSourceMeta(this.props.data.id);
    const tabs = this.props.tabs;
    const tabNames = map(tabs, 'tabName');
    let selectedTabIndex = 0;

    if (this.props.preSelectedTab) {
      const preSelectedTabIndex = tabs.findIndex(
        (item) => item.tabName == this.props.preSelectedTab,
      );
      selectedTabIndex = preSelectedTabIndex === -1 ? 0 : preSelectedTabIndex;
    }

    this.setState({ meta, tabs, tabNames, selectedTabIndex });
  }

  _getSourceMeta(objectId) {
    // for isDetected false dataset, meta data is null
    const meta = this.props.getSourceMeta ? this.props.getSourceMeta(objectId) : {};
    return meta;
  }

  _handleTabClicked(selectedTab, index) {
    this.setState({
      selectedTabIndex: index,
    });
  }

  _renderContent(selectedTabIndex, data) {
    let tabContent = null;
    const isPreSelected =
      this.props.preSelectedTab === this.state.tabs?.[selectedTabIndex]?.tabName;

    if (!isEmpty(this.state.tabs) && selectedTabIndex < this.state.tabs?.length) {
      let tabElement = this.state.tabs[selectedTabIndex].tabElement;
      //Convert element to JSX
      if (React.isValidElement(tabElement)) {
        tabContent = React.cloneElement(tabElement, {
          data,
          parentScrollRef: { current: this.detailViewRef },
          isPreSelected,
        });
      } else if (typeof tabElement === 'function') {
        tabContent = tabElement({ data, isPreSelected });
      } else {
        tabContent = <div />;
      }
    }

    return (
      <ErrorBoundary
        FallbackComponent={ErrorFallback}
        onError={(error, info) => {
          AnalyticsUtils.reportErrorToSentry(error, info);
        }}
      >
        {tabContent}
      </ErrorBoundary>
    );
  }

  _renderConditionalDetailHeader = () => {
    const { tabNames, selectedTabIndex, meta } = this.state;
    const { data, aclQueryMode, noHeaderPadding, detailHeaderContent } = this.props;

    return (
      <CardDetailViewHeader
        meta={meta}
        data={data}
        hideActions={this.props.hideActions}
        tabs={tabNames}
        noHeaderPadding={noHeaderPadding}
        aclQueryMode={aclQueryMode}
        detailHeaderContent={detailHeaderContent}
        selectedTabIndex={selectedTabIndex}
        onTabClicked={this._handleTabClicked}
      />
    );
  };

  _renderConditionalContent = () => {
    const { data } = this.props;
    const { selectedTabIndex } = this.state;

    return (
      <div className="detail-view-content" ref={(ref) => (this.detailViewRef = ref)}>
        {this._renderContent(selectedTabIndex, data)}
      </div>
    );
  };

  render() {
    const { data } = this.props;
    const { selectedTabIndex } = this.state;

    if (!data) return null;

    return (
      <section className="detail-view">
        {this._renderConditionalDetailHeader()}
        {this._renderConditionalContent()}
      </section>
    );
  }
}

export default CardDetailView;
